import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    // Clear the fragment immediately so it isn't reused
    window.history.replaceState({}, document.title, window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        toast.success(`Welcome, ${data.name}!`);
        await refresh();
        nav(data.role === "admin" ? "/admin" : "/", { replace: true });
      } catch (e) {
        toast.error(formatApiError(e) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [loc.hash, nav, refresh]);

  return (
    <div className="grid min-h-screen place-items-center">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-stone-300 border-t-stone-900" />
        <p className="mt-4 text-sm text-stone-600">Finishing sign-in…</p>
      </div>
    </div>
  );
}
